export default __webpack_public_path__ + "static/media/digital-expand.fac6152d.webp";